/* Kaddanse — « Les intercalaires du rayon » (deck nos-platines 18.08, idée 01).
   Les onglets deviennent des tabs (sans JS : de simples ancres vers les bacs
   empilés) ; les flèches font défiler le rail actif. Fichier assets — jamais
   inline (piège du morph). Ré-init sur shopify:section:load, idempotent. */
(function () {
  var REDUIT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRayon(racine) {
    if (racine.hasAttribute('data-kdd-rayon-js')) return;
    racine.setAttribute('data-kdd-rayon-js', '1');

    var onglets = Array.prototype.slice.call(racine.querySelectorAll('[data-bac-onglet]'));
    var bacs = Array.prototype.slice.call(racine.querySelectorAll('[data-bac-panel]'));
    var fleches = Array.prototype.slice.call(racine.querySelectorAll('[data-bac-fleche]'));
    if (!onglets.length || !bacs.length) return;

    function railActif() {
      var bac = racine.querySelector('.kdd-rayon__bac--on');
      return bac ? bac.querySelector('.kdd-rayon__rail') : null;
    }

    /* Les flèches se posent au milieu de l'image (comme au palmarès) :
       la hauteur de la galerie du bac actif fixe --kdd-fleches-top. */
    function poseFleches() {
      var rail = railActif();
      if (!rail) return;
      var galerie = rail.querySelector('.card-gallery');
      if (galerie && galerie.offsetHeight > 60) {
        racine.style.setProperty('--kdd-fleches-top', Math.round(galerie.offsetHeight / 2) + 'px');
      }
    }

    function majFleches() {
      var rail = railActif();
      if (!rail) return;
      var defilable = rail.scrollWidth > rail.clientWidth + 1;
      var fin = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
      fleches.forEach(function (f) {
        if (!defilable) { f.setAttribute('disabled', ''); return; }
        var arriere = f.getAttribute('data-bac-fleche') === '-1';
        var bloque = arriere ? rail.scrollLeft <= 1 : fin;
        if (bloque) f.setAttribute('disabled', '');
        else f.removeAttribute('disabled');
      });
    }

    function ouvre(cle) {
      onglets.forEach(function (o) {
        var actif = o.getAttribute('data-bac-onglet') === cle;
        o.classList.toggle('kdd-rayon__onglet--on', actif);
        o.setAttribute('aria-selected', actif ? 'true' : 'false');
      });
      bacs.forEach(function (b) {
        b.classList.toggle('kdd-rayon__bac--on', b.getAttribute('data-bac-panel') === cle);
      });
      var rail = railActif();
      if (rail) rail.scrollLeft = 0;
      poseFleches();
      majFleches();
    }

    onglets.forEach(function (o) {
      o.addEventListener('click', function (e) {
        e.preventDefault();
        ouvre(o.getAttribute('data-bac-onglet'));
      });
    });

    fleches.forEach(function (f) {
      f.addEventListener('click', function () {
        var rail = railActif();
        if (!rail) return;
        var carte = rail.firstElementChild;
        var pas = carte ? carte.getBoundingClientRect().width + 18 : rail.clientWidth * 0.8;
        rail.scrollBy({
          left: pas * parseInt(f.getAttribute('data-bac-fleche'), 10),
          behavior: REDUIT ? 'auto' : 'smooth'
        });
      });
    });

    racine.querySelectorAll('.kdd-rayon__rail').forEach(function (rail) {
      rail.addEventListener('scroll', majFleches, { passive: true });
    });
    window.addEventListener('resize', function () { poseFleches(); majFleches(); });
    /* Les images arrivent après DOMContentLoaded : la hauteur de galerie
       n'est juste qu'une fois chargées. */
    window.addEventListener('load', poseFleches);

    ouvre(onglets[0].getAttribute('data-bac-onglet'));
  }

  function init() {
    document.querySelectorAll('[data-kdd-rayon]').forEach(initRayon);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
